import { ModelApiService } from './BaseApiService'

export default class TimesheetsApiService extends ModelApiService {
  constructor() {
    super('timesheets')
  }

  async getTimesheetsSummary(clientIds) {
    return this.post('overview', { clientIds: clientIds })
  }

  async getTimesheetsFilteredByCandidate(candidateId, clientIds) {
    const urlArgs = new URLSearchParams(
      clientIds.map((clientId) => ['clientIds', clientId])
    )
    urlArgs.append('candidateId', candidateId)

    return this.get(`candidate?${urlArgs}`)
  }

  async downloadTimesheetFile(timesheetRecordId) {
    return this.getBlob(`download/${timesheetRecordId}`)
  }
}
